<div ng-controller="propertyFilterConfigController as ctrl" class="modal-view">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>